module.exports = __webpack_public_path__ + "media/images/moovejob-team-img-2-13eadddafebd487af6274dcd37a025ce.jpeg";